import { getMyGossipList, setMyGossipList } from '@/utils/storage'
export default {
  namespaced: true,
  state () {
    return {
      // 个人商品列表
      myGossipsList: getMyGossipList()
    }
  },
  getters: {

  },
  mutations: {
    setMyGossipList (state, obj) {
      state.myGossipsList = obj
      setMyGossipList(obj)
    }
  },
  actions: {
  }
}
